export default __webpack_public_path__ + "static/recipes-3944fb1ab6043d4110de724d7c2fe096.mp4";